import { FC, useRef, useState } from 'react';
import { ACTION_REASON_MAX_LENGTH } from '@organisms/actions/ActionReason/actionReason';
import './DirectWriteConfirm.scss';

interface IDirectWriteConfirmProps {
    docId: string;
    fieldName: string;
    before: string;
    after: string;
    /** Запись идёт: подтверждение остаётся на экране и показывает ход. */
    writing: boolean;
    onConfirm: (reason: string) => void;
    onCancel: () => void;
}

/**
 * Подтверждение прямой записи жучком на PROD: «было → стало» и обязательная причина с тем же
 * лимитом, что у действий с причиной.
 */
const DirectWriteConfirm: FC<IDirectWriteConfirmProps> = ({
    docId,
    fieldName,
    before,
    after,
    writing,
    onConfirm,
    onCancel,
}) => {
    const [reason, setReason] = useState('');
    const [invalid, setInvalid] = useState(false);
    const inputRef = useRef<HTMLInputElement>(null);

    const confirm = () => {
        if (writing) return;
        const trimmed = reason.trim();
        if (!trimmed) {
            setInvalid(true);
            inputRef.current?.focus();
            return;
        }
        onConfirm(trimmed);
    };

    return (
        <div className="rf-direct-write-confirm" role="group" aria-label="Подтверждение прямой записи">
            <div className="rf-direct-write-confirm__title">
                Запись в рабочую базу: <b>{docId}</b> › {fieldName}
            </div>
            <div className="rf-direct-write-confirm__delta">
                <del title={before}>{before}</del>
                <span aria-hidden>→</span>
                <ins title={after}>{after}</ins>
            </div>
            <label className="rf-direct-write-confirm__reason">
                <span>Причина или номер обращения</span>
                <input
                    ref={inputRef}
                    value={reason}
                    maxLength={ACTION_REASON_MAX_LENGTH}
                    onChange={(event) => {
                        setReason(event.target.value);
                        setInvalid(false);
                    }}
                    onKeyDown={(event) => {
                        event.stopPropagation();
                        if (event.key === 'Enter') confirm();
                        if (event.key === 'Escape') onCancel();
                    }}
                    aria-invalid={invalid || undefined}
                    disabled={writing}
                    autoFocus
                />
            </label>
            {invalid && (
                <div className="rf-direct-write-confirm__invalid" role="alert">
                    Укажите причину записи.
                </div>
            )}
            <div className="rf-direct-write-confirm__actions">
                <button type="button" onClick={onCancel} disabled={writing}>
                    Отмена
                </button>
                <button type="button" className="rf-direct-write-confirm__primary" onClick={confirm} disabled={writing}>
                    {writing ? 'Запись…' : 'Да, записать'}
                </button>
            </div>
        </div>
    );
};

export default DirectWriteConfirm;
